import { render, staticRenderFns } from "./defaultEreceiptForm.vue?vue&type=template&id=52fe2b8a&scoped=true&"
import script from "./defaultEreceiptForm.vue?vue&type=script&lang=js&"
export * from "./defaultEreceiptForm.vue?vue&type=script&lang=js&"
import style0 from "./defaultEreceiptForm.vue?vue&type=style&index=0&id=52fe2b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe2b8a",
  null
  
)

export default component.exports